import React from "react";
import NavAnchor from "@template/components/Navigation/NavAnchor";
import LazyImage from "@template/components/LazyImage";
import { navigationItemPropType } from "@template/state/modules/navigation";
import { getBackgroundImageUrl } from "@template/helpers/navigationBackgroundImageResolver";
import { createIdAriaDescribedBy } from "@template/helpers/navigationAccessibility";

import styles from "./index.css";
import classnames from "classnames";

const cx = classnames.bind(styles);

const MAX_ITEM_COUNT = 4;
const MAX_LETTER_COUNT = 26;

const GridCircleImage = ({ item }) => {
  const items = [].concat(item.items);
  const { label } = item;
  const headerId = createIdAriaDescribedBy(label);

  return (
    <ul className={styles.container} aria-labelledby={headerId}>
      {items.splice(0, MAX_ITEM_COUNT).map(gridItem)}
    </ul>
  );
};

const gridItem = item => (
  <li
    key={item.id}
    className={cx(styles.gridItem, {
      [styles.gridItem__sale]: item.largeScreenStyleType === "sale"
    })}
  >
    <NavAnchor item={item}>
      <div className={styles.gridItemImageBorder}>
        <LazyImage
          aria-hidden="true"
          className={styles.gridItemImage}
          role="presentation"
          src={getBackgroundImageUrl(item.largeScreenImageUrl, 240)}
          title={item.label}
          tag={"div"}
          loadingColor={"silver"}
        />
      </div>
      <span className={styles.itemLabel}>
        {item.label.substr(0, MAX_LETTER_COUNT)}
      </span>
    </NavAnchor>
  </li>
);

GridCircleImage.propTypes = {
  item: navigationItemPropType.isRequired
};

export default GridCircleImage;
